import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const BeigabenServiceConfig = {
  name: "Beigaben",
  annotations: []
} as ServiceConfig;